import React from 'react';
import { withRouter } from 'react-router-dom';
import RenewalsPortalPageHeaderWrapper from '../RenewalsPortalPageHeaderWrapper/RenewalsPortalPageHeaderWrapper';
import CustomerTableWrapper from '../CustomerRenewalTableWrapper/CustomerRenewalTableWrapper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import PageBase from '../../../widgets/PageBase/PageBase';
import { injectIntl } from 'react-intl';

class RenewalsPortal extends React.Component {
  render() {
    return (
      <PageBase
        navigation={[
          this.props.intl.formatMessage({
            id: 'nav.renewal_portal'
          })
        ]}
        noWrapContent
        loading={this.props.renewalsPortalStore.loadingGroup.isLoading}
      >
        <RenewalsPortalPageHeaderWrapper />
        <CustomerTableWrapper />
      </PageBase>
    );
  }
}

const mapStateToProps = (state) => ({
  renewalsPortalStore: state.get('renewalsPortal').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RenewalsPortal))
);
